<div *ngFor="let section of sections">
  <div [innerHTML]="section.body | mdToHtml"></div>
  <app-prism-xml *ngIf="section.xmlData" [xmlData]="section.xmlData"></app-prism-xml>
  <div [innerHTML]="section.subBody || '' | mdToHtml"></div>
</div>
